import { useState } from 'react';
import { SelectOption } from '../components/common/SearchableSelect/SearchableSelect';

/** Complete list of countries/territories (ISO 3166-1 alpha-2) with Portuguese names */
const ALL_COUNTRIES: SelectOption[] = [
  { value: 'BR', label: 'Brasil' },
  { value: 'AF', label: 'Afeganistão' },
  { value: 'ZA', label: 'África do Sul' },
  { value: 'AL', label: 'Albânia' },
  { value: 'DE', label: 'Alemanha' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AG', label: 'Antígua e Barbuda' },
  { value: 'SA', label: 'Arábia Saudita' },
  { value: 'DZ', label: 'Argélia' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armênia' },
  { value: 'AU', label: 'Austrália' },
  { value: 'AT', label: 'Áustria' },
  { value: 'AZ', label: 'Azerbaijão' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BH', label: 'Barein' },
  { value: 'BE', label: 'Bélgica' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benim' },
  { value: 'BY', label: 'Bielorrússia' },
  { value: 'BO', label: 'Bolívia' },
  { value: 'BA', label: 'Bósnia e Herzegovina' },
  { value: 'BW', label: 'Botsuana' },
  { value: 'BN', label: 'Brunei' },
  { value: 'BG', label: 'Bulgária' },
  { value: 'BF', label: 'Burquina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'BT', label: 'Butão' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'CM', label: 'Camarões' },
  { value: 'KH', label: 'Camboja' },
  { value: 'CA', label: 'Canadá' },
  { value: 'QA', label: 'Catar' },
  { value: 'KZ', label: 'Cazaquistão' },
  { value: 'TD', label: 'Chade' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CY', label: 'Chipre' },
  { value: 'CO', label: 'Colômbia' },
  { value: 'KM', label: 'Comores' },
  { value: 'CG', label: 'Congo' },
  { value: 'KP', label: 'Coreia do Norte' },
  { value: 'KR', label: 'Coreia do Sul' },
  { value: 'CI', label: 'Costa do Marfim' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croácia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'DK', label: 'Dinamarca' },
  { value: 'DJ', label: 'Djibuti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'EG', label: 'Egito' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'AE', label: 'Emirados Árabes Unidos' },
  { value: 'EC', label: 'Equador' },
  { value: 'ER', label: 'Eritreia' },
  { value: 'SK', label: 'Eslováquia' },
  { value: 'SI', label: 'Eslovênia' },
  { value: 'ES', label: 'Espanha' },
  { value: 'US', label: 'Estados Unidos' },
  { value: 'EE', label: 'Estônia' },
  { value: 'SZ', label: 'Esuatíni' },
  { value: 'ET', label: 'Etiópia' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'PH', label: 'Filipinas' },
  { value: 'FI', label: 'Finlândia' },
  { value: 'FR', label: 'França' },
  { value: 'GA', label: 'Gabão' },
  { value: 'GM', label: 'Gâmbia' },
  { value: 'GH', label: 'Gana' },
  { value: 'GE', label: 'Geórgia' },
  { value: 'GD', label: 'Granada' },
  { value: 'GR', label: 'Grécia' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GY', label: 'Guiana' },
  { value: 'GN', label: 'Guiné' },
  { value: 'GQ', label: 'Guiné Equatorial' },
  { value: 'GW', label: 'Guiné-Bissau' },
  { value: 'HT', label: 'Haiti' },
  { value: 'NL', label: 'Holanda' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HU', label: 'Hungria' },
  { value: 'YE', label: 'Iêmen' },
  { value: 'IN', label: 'Índia' },
  { value: 'ID', label: 'Indonésia' },
  { value: 'IQ', label: 'Iraque' },
  { value: 'IR', label: 'Irã' },
  { value: 'IE', label: 'Irlanda' },
  { value: 'IS', label: 'Islândia' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Itália' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japão' },
  { value: 'JO', label: 'Jordânia' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'LA', label: 'Laos' },
  { value: 'LS', label: 'Lesoto' },
  { value: 'LV', label: 'Letônia' },
  { value: 'LB', label: 'Líbano' },
  { value: 'LR', label: 'Libéria' },
  { value: 'LY', label: 'Líbia' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lituânia' },
  { value: 'LU', label: 'Luxemburgo' },
  { value: 'MK', label: 'Macedônia do Norte' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MY', label: 'Malásia' },
  { value: 'MW', label: 'Maláui' },
  { value: 'MV', label: 'Maldivas' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MA', label: 'Marrocos' },
  { value: 'MU', label: 'Maurício' },
  { value: 'MR', label: 'Mauritânia' },
  { value: 'MX', label: 'México' },
  { value: 'MM', label: 'Mianmar' },
  { value: 'FM', label: 'Micronésia' },
  { value: 'MZ', label: 'Moçambique' },
  { value: 'MD', label: 'Moldávia' },
  { value: 'MC', label: 'Mônaco' },
  { value: 'MN', label: 'Mongólia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'NA', label: 'Namíbia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NI', label: 'Nicarágua' },
  { value: 'NE', label: 'Níger' },
  { value: 'NG', label: 'Nigéria' },
  { value: 'NO', label: 'Noruega' },
  { value: 'NZ', label: 'Nova Zelândia' },
  { value: 'OM', label: 'Omã' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestina' },
  { value: 'PA', label: 'Panamá' },
  { value: 'PG', label: 'Papua-Nova Guiné' },
  { value: 'PK', label: 'Paquistão' },
  { value: 'PY', label: 'Paraguai' },
  { value: 'PE', label: 'Peru' },
  { value: 'PL', label: 'Polônia' },
  { value: 'PT', label: 'Portugal' },
  { value: 'KE', label: 'Quênia' },
  { value: 'KG', label: 'Quirguistão' },
  { value: 'KI', label: 'Quiribáti' },
  { value: 'GB', label: 'Reino Unido' },
  { value: 'CF', label: 'República Centro-Africana' },
  { value: 'CD', label: 'República Democrática do Congo' },
  { value: 'DO', label: 'República Dominicana' },
  { value: 'CZ', label: 'República Tcheca' },
  { value: 'RO', label: 'Romênia' },
  { value: 'RW', label: 'Ruanda' },
  { value: 'RU', label: 'Rússia' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'LC', label: 'Santa Lúcia' },
  { value: 'KN', label: 'São Cristóvão e Névis' },
  { value: 'ST', label: 'São Tomé e Príncipe' },
  { value: 'VC', label: 'São Vicente e Granadinas' },
  { value: 'SC', label: 'Seicheles' },
  { value: 'SN', label: 'Senegal' },
  { value: 'SL', label: 'Serra Leoa' },
  { value: 'RS', label: 'Sérvia' },
  { value: 'SG', label: 'Singapura' },
  { value: 'SY', label: 'Síria' },
  { value: 'SO', label: 'Somália' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudão' },
  { value: 'SS', label: 'Sudão do Sul' },
  { value: 'SE', label: 'Suécia' },
  { value: 'CH', label: 'Suíça' },
  { value: 'SR', label: 'Suriname' },
  { value: 'TJ', label: 'Tadjiquistão' },
  { value: 'TH', label: 'Tailândia' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TZ', label: 'Tanzânia' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad e Tobago' },
  { value: 'TN', label: 'Tunísia' },
  { value: 'TM', label: 'Turcomenistão' },
  { value: 'TR', label: 'Turquia' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UA', label: 'Ucrânia' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UY', label: 'Uruguai' },
  { value: 'UZ', label: 'Uzbequistão' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VA', label: 'Vaticano' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnã' },
  { value: 'ZM', label: 'Zâmbia' },
  { value: 'ZW', label: 'Zimbábue' },
  { value: 'AW', label: 'Aruba' },
  { value: 'BM', label: 'Bermudas' },
  { value: 'KY', label: 'Ilhas Cayman' },
  { value: 'VG', label: 'Ilhas Virgens Britânicas' },
  { value: 'VI', label: 'Ilhas Virgens dos EUA' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'MF', label: 'São Martinho' },
  { value: 'SX', label: 'Sint Maarten' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'GL', label: 'Groenlândia' },

  { value: 'GI', label: 'Gibraltar' },
  { value: 'FO', label: 'Ilhas Faroe' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'JE', label: 'Jersey' },
  { value: 'IM', label: 'Ilha de Man' },

  { value: 'HK', label: 'Hong Kong' },
  { value: 'MO', label: 'Macau' },

  { value: 'YT', label: 'Mayotte' },
  { value: 'RE', label: 'Reunião' },
  { value: 'SH', label: 'Santa Helena' },

  { value: 'CK', label: 'Ilhas Cook' },
  { value: 'NU', label: 'Niue' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'AS', label: 'Samoa Americana' },
  { value: 'PF', label: 'Polinésia Francesa' },
  { value: 'NC', label: 'Nova Caledônia' },
  { value: 'WF', label: 'Wallis e Futuna' },
  { value: 'MH', label: 'Ilhas Marshall' },
];

export function useCountries(): { countries: SelectOption[]; loading: boolean } {
  return { countries: ALL_COUNTRIES, loading: false };
}
